//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../axios-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * @return OK
 */
export function savingsGoalsGetList(config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfLookupDtoOfGuid> {
    let url_ = getBaseUrl() + "/api/savings-goals";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSavingsGoalsGetList,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSavingsGoalsGetList?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSavingsGoalsGetList(_response);
    });
}

function processSavingsGoalsGetList(response: AxiosResponse): Promise<Types.ListResultDtoOfLookupDtoOfGuid> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfLookupDtoOfGuid>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfLookupDtoOfGuid>(null as any);
}

/**
 * @return OK
 */
export function savingsGoalsGet(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.SavingsGoalDto> {
    let url_ = getBaseUrl() + "/api/savings-goals/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSavingsGoalsGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSavingsGoalsGet?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSavingsGoalsGet(_response);
    });
}

function processSavingsGoalsGet(response: AxiosResponse): Promise<Types.SavingsGoalDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.SavingsGoalDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SavingsGoalDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function savingsGoalsUpdate(id: string, body?: Types.SavingsGoalCreateOrUpdateDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SavingsGoalDto> {
    let url_ = getBaseUrl() + "/api/savings-goals/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSavingsGoalsUpdate,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigSavingsGoalsUpdate?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSavingsGoalsUpdate(_response);
    });
}

function processSavingsGoalsUpdate(response: AxiosResponse): Promise<Types.SavingsGoalDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.SavingsGoalDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SavingsGoalDto>(null as any);
}

/**
 * @return OK
 */
export function savingsGoalsDelete(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/savings-goals/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSavingsGoalsDelete,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigSavingsGoalsDelete?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSavingsGoalsDelete(_response);
    });
}

function processSavingsGoalsDelete(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @param currency (optional) 
 * @param contribution (optional) 
 * @param contributionType (optional) 
 * @param annualReturns (optional) 
 * @return OK
 */
export function savingsGoalsGetSavingsGoalPreview(name: string, startDate: string, endDate: string, goalValue: number, portfolios: string[], currency?: string | undefined, contribution?: number | undefined, contributionType?: Types.ContributionType | undefined, annualReturns?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SavingsGoalPreviewDto> {
    let url_ = getBaseUrl() + "/api/savings-goals/preview?";
      if (name === undefined || name === null)
        throw new Error("The parameter 'name' must be defined and cannot be null.");
      else
        url_ += "Name=" + encodeURIComponent("" + name) + "&";
      if (startDate === undefined || startDate === null)
        throw new Error("The parameter 'startDate' must be defined and cannot be null.");
      else
        url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
      if (endDate === undefined || endDate === null)
        throw new Error("The parameter 'endDate' must be defined and cannot be null.");
      else
        url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
      if (goalValue === undefined || goalValue === null)
        throw new Error("The parameter 'goalValue' must be defined and cannot be null.");
      else
        url_ += "GoalValue=" + encodeURIComponent("" + goalValue) + "&";
      if (portfolios === undefined || portfolios === null)
        throw new Error("The parameter 'portfolios' must be defined and cannot be null.");
      else
        portfolios && portfolios.forEach(item => { url_ += "Portfolios=" + encodeURIComponent("" + item) + "&"; });
    if (currency === null)
        throw new Error("The parameter 'currency' cannot be null.");
    else if (currency !== undefined)
        url_ += "Currency=" + encodeURIComponent("" + currency) + "&";
    if (contribution === null)
        throw new Error("The parameter 'contribution' cannot be null.");
    else if (contribution !== undefined)
        url_ += "Contribution=" + encodeURIComponent("" + contribution) + "&";
    if (contributionType === null)
        throw new Error("The parameter 'contributionType' cannot be null.");
    else if (contributionType !== undefined)
        url_ += "ContributionType=" + encodeURIComponent("" + contributionType) + "&";
    if (annualReturns === null)
        throw new Error("The parameter 'annualReturns' cannot be null.");
    else if (annualReturns !== undefined)
        url_ += "AnnualReturns=" + encodeURIComponent("" + annualReturns) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSavingsGoalsGetSavingsGoalPreview,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSavingsGoalsGetSavingsGoalPreview?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSavingsGoalsGetSavingsGoalPreview(_response);
    });
}

function processSavingsGoalsGetSavingsGoalPreview(response: AxiosResponse): Promise<Types.SavingsGoalPreviewDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.SavingsGoalPreviewDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SavingsGoalPreviewDto>(null as any);
}

/**
 * @return OK
 */
export function savingsGoalsGetSavingsGoalProgress(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.SavingsGoalCalculationDto> {
    let url_ = getBaseUrl() + "/api/savings-goals/{id}/progress";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSavingsGoalsGetSavingsGoalProgress,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSavingsGoalsGetSavingsGoalProgress?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSavingsGoalsGetSavingsGoalProgress(_response);
    });
}

function processSavingsGoalsGetSavingsGoalProgress(response: AxiosResponse): Promise<Types.SavingsGoalCalculationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.SavingsGoalCalculationDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SavingsGoalCalculationDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function savingsGoalsCreate(body?: Types.SavingsGoalCreateOrUpdateDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SavingsGoalDto> {
    let url_ = getBaseUrl() + "/api/savings-goals/create";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSavingsGoalsCreate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSavingsGoalsCreate?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSavingsGoalsCreate(_response);
    });
}

function processSavingsGoalsCreate(response: AxiosResponse): Promise<Types.SavingsGoalDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.SavingsGoalDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SavingsGoalDto>(null as any);
}
let _requestConfigSavingsGoalsGetList: Partial<AxiosRequestConfig> | null;
export function getSavingsGoalsGetListRequestConfig() {
  return _requestConfigSavingsGoalsGetList;
}
export function setSavingsGoalsGetListRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsGetList = value;
}
export function patchSavingsGoalsGetListRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsGetList = patch(_requestConfigSavingsGoalsGetList ?? {});
}

let _requestConfigSavingsGoalsGet: Partial<AxiosRequestConfig> | null;
export function getSavingsGoalsGetRequestConfig() {
  return _requestConfigSavingsGoalsGet;
}
export function setSavingsGoalsGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsGet = value;
}
export function patchSavingsGoalsGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsGet = patch(_requestConfigSavingsGoalsGet ?? {});
}

let _requestConfigSavingsGoalsUpdate: Partial<AxiosRequestConfig> | null;
export function getSavingsGoalsUpdateRequestConfig() {
  return _requestConfigSavingsGoalsUpdate;
}
export function setSavingsGoalsUpdateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsUpdate = value;
}
export function patchSavingsGoalsUpdateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsUpdate = patch(_requestConfigSavingsGoalsUpdate ?? {});
}

let _requestConfigSavingsGoalsDelete: Partial<AxiosRequestConfig> | null;
export function getSavingsGoalsDeleteRequestConfig() {
  return _requestConfigSavingsGoalsDelete;
}
export function setSavingsGoalsDeleteRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsDelete = value;
}
export function patchSavingsGoalsDeleteRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsDelete = patch(_requestConfigSavingsGoalsDelete ?? {});
}

let _requestConfigSavingsGoalsGetSavingsGoalPreview: Partial<AxiosRequestConfig> | null;
export function getSavingsGoalsGetSavingsGoalPreviewRequestConfig() {
  return _requestConfigSavingsGoalsGetSavingsGoalPreview;
}
export function setSavingsGoalsGetSavingsGoalPreviewRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsGetSavingsGoalPreview = value;
}
export function patchSavingsGoalsGetSavingsGoalPreviewRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsGetSavingsGoalPreview = patch(_requestConfigSavingsGoalsGetSavingsGoalPreview ?? {});
}

let _requestConfigSavingsGoalsGetSavingsGoalProgress: Partial<AxiosRequestConfig> | null;
export function getSavingsGoalsGetSavingsGoalProgressRequestConfig() {
  return _requestConfigSavingsGoalsGetSavingsGoalProgress;
}
export function setSavingsGoalsGetSavingsGoalProgressRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsGetSavingsGoalProgress = value;
}
export function patchSavingsGoalsGetSavingsGoalProgressRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsGetSavingsGoalProgress = patch(_requestConfigSavingsGoalsGetSavingsGoalProgress ?? {});
}

let _requestConfigSavingsGoalsCreate: Partial<AxiosRequestConfig> | null;
export function getSavingsGoalsCreateRequestConfig() {
  return _requestConfigSavingsGoalsCreate;
}
export function setSavingsGoalsCreateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsCreate = value;
}
export function patchSavingsGoalsCreateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSavingsGoalsCreate = patch(_requestConfigSavingsGoalsCreate ?? {});
}